import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';

i18n
  .use(HttpBackend) // Carga traducciones desde múltiples archivos
  .use(LanguageDetector) // Detecta el idioma del navegador
  .use(initReactI18next) // Inicializa i18next para React
  .init({
    fallbackLng: 'en', // Idioma predeterminado
    debug: true, // Depuración
    interpolation: {
      escapeValue: false, // No escapa caracteres (React ya maneja esto)
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json', // Ruta de los archivos de traducción
    },
    ns: ['home'], // Define namespaces (ejemplo: 'home')
    defaultNS: 'home', // Namespace predeterminado
  });

export default i18n;
